import React from "react";

import {Button, IconButton, InputAdornment, MenuItem, TextField, Typography} from "@material-ui/core";
import {AccountCircleRounded, LockRounded, VisibilityOffRounded, VisibilityRounded, VpnKeyRounded} from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse";
import {enviroment} from 'enviroment';

export const LoginForm = props => {
    const {
        values,
        status,
        errors,
        touched,
        handleSubmit,
        handleChange,
        isValid,
        setFieldTouched,
        setFieldValue,
        setStatus,
        isTokenRequired
    } = props;

    const onChange = (name, e) => {
        e.persist();
        handleChange(e);
        setFieldTouched(name, true, false);
        setStatus({error: false});
    };

    return (
        <form className='form' onSubmit={handleSubmit}>
            <TextField
                select
                label="Servidor"
                value={values.apiUrl}
                onChange={e => setFieldValue('apiUrl', e.target.value)}
                fullWidth
                variant="outlined"
                className='mb-3'
            >
                {enviroment.servers.map(option => (
                    option.url && (
                        <MenuItem key={option.url} value={option.url} selected={option.url === values.apiUrl}>
                            {option.name}
                        </MenuItem>
                    )
                ))}
            </TextField>
            <TextField
                name='username'
                helperText={touched.username ? errors.username : ''}
                error={touched.username && Boolean(errors.username)}
                value={values.username}
                onChange={onChange.bind(null, 'username')}
                fullWidth
                variant="outlined"
                label="Usuario"
                className='mb-3'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <AccountCircleRounded/>
                        </InputAdornment>
                    ),
                }}
            />
            <TextField
                name='password'
                type={values.showPassword ? 'text' : 'password'}
                helperText={touched.password ? errors.password : ''}
                error={touched.password && Boolean(errors.password)}
                value={values.password}
                onChange={onChange.bind(null, 'password')}
                fullWidth
                variant="outlined"
                label="Contraseña"
                className='mb-3'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <LockRounded/>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="Toggle password visibility"
                                onClick={() => setFieldValue('showPassword', !values.showPassword, false)}
                            >
                                {values.showPassword ? <VisibilityOffRounded/> : <VisibilityRounded/>}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Collapse in={isTokenRequired(values.username)}>
                <TextField
                    name='softtoken'
                    helperText={touched.softtoken ? errors.softtoken : ''}
                    error={touched.softtoken && Boolean(errors.softtoken)}
                    value={values.softtoken}
                    onChange={onChange.bind(null, 'softtoken')}
                    fullWidth
                    variant="outlined"
                    label="Token"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <VpnKeyRounded/>
                            </InputAdornment>
                        ),
                    }}
                />
            </Collapse>
            {
                status && status.error && status.message &&
                <Typography className='mt-2' variant='caption' color='error'>{status.message}</Typography>
            }
            <div className='confirmation mt-2'>
                <Button disabled={!isValid} type="submit" variant="contained" color="primary" fullWidth className='mb-2'>
                    Login
                </Button>
                <Button color="primary" fullWidth>
                    Olvidé mi contraseña
                </Button>
            </div>
        </form>
    )
};
